import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const fetchPaymentConfig = createAsyncThunk(
  'paymentConfig/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await $axios.get('/payment-config');
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to load payment config');
    }
  }
);

export const updatePaymentConfig = createAsyncThunk(
  'paymentConfig/update',
  async (payload, { rejectWithValue }) => {
    try {
      const res = await $axios.patch('/payment-config', payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to save payment config');
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  updating: false,
  error: null,
};

const paymentConfigSlice = createSlice({
  name: 'paymentConfig',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPaymentConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePaymentConfig.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updatePaymentConfig.fulfilled, (state, action) => {
        state.updating = false;
        state.data = action.payload;
      })
      .addCase(updatePaymentConfig.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = paymentConfigSlice.actions;
export default paymentConfigSlice.reducer;
